import { render, staticRenderFns } from "./FormAliasesAddGroup.vue?vue&type=template&id=671b6a83&scoped=true&"
import script from "./FormAliasesAddGroup.vue?vue&type=script&lang=js&"
export * from "./FormAliasesAddGroup.vue?vue&type=script&lang=js&"
import style0 from "./FormAliasesAddGroup.vue?vue&type=style&index=0&id=671b6a83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671b6a83",
  null
  
)

export default component.exports